export default function () {
    return {
        catalogTree: [],
        inspirationsTree: [],
        forumTree: [],
        newspaperData: null,
    };
}
